module.exports = __webpack_public_path__ + "static/media/icon-0.00930ef1.svg";